/* eslint-disable no-restricted-globals */
/* eslint-disable */
import react, { useEffect, useState } from "react";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";

import { useHistory, useLocation, useParams } from "react-router-dom";
import { useOportunidadesLeadDetalhe } from "services/api/AppWeb_Oportunidade/oportunidades-lead-detalhe";
import { PropostaCard } from "./components/propostaCard";
import { HistoricoCard } from "./components/historicoCard";
import { useHistorico } from "services/api/AppWeb_Oportunidade/get-historico";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";

export function OportunidadesDetail() {
  const params: any = useParams();
  const location = useLocation<{ from?: string }>();
  const [search, setSearch] = useState({
    palavraChave: "",
    searching: false,
  });
  // Termo efetivamente aplicado na consulta. Só muda quando o usuário
  // confirma a busca (ou limpa o campo), evitando refetch a cada tecla.
  const [palavraChaveAplicada, setPalavraChaveAplicada] = useState("");
  const { codigoCargo2013, usuarioCia, usuarioBackofficeVivaz } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  const isSupervisor = codigoCargo2013 === CARGO_CODES.SUPERVISOR;
  const isCoordenador = codigoCargo2013 === CARGO_CODES.COORDENADOR_PRODUTO;
  const funnelBackPath =
    location.state?.from === "/funil-comercial"
      ? "/funil-comercial"
      : location.state?.from === "/funil-de-propostas"
      ? "/funil-de-propostas"
      : undefined;
  const funnelBackName =
    funnelBackPath === "/funil-comercial"
      ? "Funil Comercial"
      : "Funil de propostas";

  const {
    data: dataDetalheOportunidade,
    refetch: refetchDetalheOportunidade,
    isLoading: isLoadingDetalheOportunidade,
  } = useOportunidadesLeadDetalhe({
    numeroCotacao: params?.numeroCotacao,
  });
  const {
    historico,
    refetch: refetchHistorico,
    isFetching: isFetchingHistorico,
    isFetchingNextPage: isFetchingNextPageHistorico,
    fetchNextPage: fetchNextPageHistorico,
    hasNextPage: hasNextPageHistorico,
  } = useHistorico({
    idOportunidade: dataDetalheOportunidade?.idOportunidade,
    totalItensRetorno: 10,
    palavraChave: palavraChaveAplicada || undefined,
  });

  // Ao limpar o campo, volta para a listagem completa. Trocar
  // `palavraChaveAplicada` troca a queryKey, então o React Query reinicia
  // a paginação sozinho — sem refetch manual.
  useEffect(() => {
    if (search.searching && search.palavraChave.trim().length === 0) {
      setSearch((prev) => ({ ...prev, searching: false }));
      setPalavraChaveAplicada("");
    }
  }, [search.searching, search.palavraChave]);

  const history = useHistory();

  // Monitora mudanças no idLeadCorretor365 após refetch
  useEffect(() => {
    if (
      dataDetalheOportunidade?.idLeadCorretor365 &&
      dataDetalheOportunidade?.idLeadCorretor365 !== params.idLeadCorretor
    ) {
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace(
        `/lead-detail/${params.idLeadCorretor}/`,
        `/lead-detail/${dataDetalheOportunidade.idLeadCorretor365}/`
      );
      history.replace(newPath);
    }
  }, [
    dataDetalheOportunidade?.idLeadCorretor365,
    params.idLeadCorretor,
    history,
  ]);

  return (
    <>
      <NavCommon
        breadcrumbs={
          usuarioBackofficeVivaz
            ? [
                {
                  path: funnelBackPath || "/funil-de-propostas",
                  name: funnelBackName,
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`,
                  name: "Propostas",
                },
              ]
            : isSupervisor || isCoordenador
            ? [
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`,
                  name: "Propostas",
                },
              ]
            : [
                { path: "/leads", name: `Carteira` },
                {
                  path: `/lead-detail/${params.idLeadCorretor}`,
                  name: "Detalhes do lead",
                },
                {
                  path: `/lead-detail/${params.idLeadCorretor}/proposition-detail/${params.numeroCotacao}`,
                  name: "Propostas",
                },
              ]
        }
        showButtonNew
        onBack={() => {
          if (location.state?.from === "/funil-comercial") {
            history.push("/funil-comercial");
          } else {
            history.goBack();
          }
          localStorage.setItem("@sell.it/previousScreen", window.location.href);
        }}
        open
        onChangeActionNew={undefined}
      />
      <S.Container>
        <PropostaCard
          params={params}
          dataDetalheOportunidade={dataDetalheOportunidade}
          refetchDetalheOportunidade={refetchDetalheOportunidade}
          refetchHistorico={refetchHistorico}
          isLoading={isLoadingDetalheOportunidade}
          funnelBackPath={funnelBackPath}
          navigationState={location.state}
        />
        <HistoricoCard
          data={dataDetalheOportunidade}
          isLoading={isLoadingDetalheOportunidade}
          historico={historico}
          search={search}
          setSearch={setSearch}
          onAplicarBusca={setPalavraChaveAplicada}
          refetchHistorico={refetchHistorico}
          refetchDetalheOportunidade={refetchDetalheOportunidade}
          isFetchingHistorico={isFetchingHistorico}
          isFetchingNextPage={isFetchingNextPageHistorico}
          fetchNextPage={fetchNextPageHistorico}
          hasNextPage={Boolean(hasNextPageHistorico)}
        />
      </S.Container>
    </>
  );
}
